/** 관리자 메일 발송·문의 안내 공통 발신/연락 주소 */
export const ADMIN_MAIL_SENDER = 'yeplat-cs@naver.com';
